import axios from './base'
import { get } from './axios/fetch.base.url'
const url = `/mine`

// 个人中心 / 消息中心：只操作「当前登录账号自己」的接口，管别人的仍在 system.js
// - GET  /mine/info：当前登录人资料（姓名/手机号/性别等）
// - POST /mine/change/password：入参 { old_password, new_password, confirm_password }
//   （新密码 6-20 位、不能与原密码相同、两次输入必须一致；三项服务端都会再校一遍）
//   成功后旧 token 立即失效，前端强制退出重新登录
// - GET  /mine/message：我的通知 / 我的消息列表
//   params: scene(notice=后台公告 / message=业务提醒)、type(仅业务提醒 1-5)、read(0未读 1已读)、page、page_size
//   响应 list/total/page/page_size/unread_count；每条带统一后的 can_read/is_read（全体公告逐人已读在后端按人记录）
// - GET  /mine/message/unread：顶栏角标未读数 { notice, message }（含全体公告未读；公告发布/删除有 SSE 推送，角标即时变）
// - PUT  /mine/message/{id}/read：标为已读（全体公告也支持，重复标记幂等）
// - PUT  /mine/message/read-all：该场景未读全部标为已读，入参 { scene }
// - PUT  /mine/info：编辑资料 —— 后端尚未开发
// - GET  /mine/message/stream：实时通道（SSE），见下方 messageStreamUrl

/**
 * 实时通道地址（SSE 长连接）
 *
 * 走 EventSource，而 EventSource 不支持自定义请求头，所以 token 只能放 query；
 * 后端由 SseAuthMiddleware 专门校验这个参数（其余接口仍走 Authorization 头）。
 * 返回绝对地址：前端与接口域名不同源，EventSource 必须用完整 URL。
 */
export function messageStreamUrl() {
  const token = localStorage.getItem('token') || ''
  return `${get().manageUrl}/mine/message/stream?token=${encodeURIComponent(token)}`
}

export function getProfile(data = {}) {
  return axios.request({
    url: `${url}/info`,
    method: "get",
    params: data,
  })
}

export function updateProfile(data = {}) {
  return axios.request({
    url: `${url}/info`,
    method: "put",
    data,
  })
}

export function changePassword(data = {}) {
  return axios.request({
    url: `${url}/change/password`,
    method: "post",
    data,
  })
}

export function getMessageList(data = {}) {
  return axios.request({
    url: `${url}/message`,
    method: "get",
    params: data,
  })
}

export function getMessageUnread() {
  return axios.request({
    url: `${url}/message/unread`,
    method: "get",
  })
}

export function readMessage(id) {
  return axios.request({
    url: `${url}/message/${id}/read`,
    method: "put",
  })
}

export function readAllMessage(data = {}) {
  return axios.request({
    url: `${url}/message/read-all`,
    method: "put",
    data,
  })
}
